import { BiArrowBack } from 'react-icons/bi'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomerDetail from './CustomerDetail'
import AuctionDetail from './autionDetail/AuctionDetail'
import classNames from 'classnames'
import OAppointments from 'components/reusable/OAppointments'
import AuthContext from 'context/AuthContext'

const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-lime-500 text-lime-500'
const tabBorderNoneClass = 'border-transparent'
const TAB_CUSTOMER_DETAIL = 'customer_detail'
const TAB_AUCTION_DETAIL = 'auction_detail'
export const TAB_APPOINTMENT_DETAIL = 'appointment_detail'

function CustomerViewPage () {
  const { tab, setTab } = useContext(AuthContext)
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [defaultTab, setDefaultTab] = useState('customer_detail')
  const [item] = useState(location?.state?.item)

  const handleTabClick = (action, e) => {
    setDefaultTab(action)
  }
  useEffect(() => {
    if (tab) {
      setDefaultTab(tab)
    }
    // eslint-disable-next-line
  }, [])
  return (
    <>
      <div className='p-10 py-2 pt-4'>
        <div className='flex border-b mb-4'>
          <span
            className='flex  items-center cursor-pointer'
            onClick={() => {
              navigate(-1)
              setTab('')
            }}
          >
            <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2' />
            <span className='ml-2'>{t('O_BACK')}</span>
          </span>

          <div className=''>
            <ul className='flex'>
              <li className='mr-0 xl:mr-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_CUSTOMER_DETAIL)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_CUSTOMER_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_CUSTOMER_DETAIL
                  })}
                >
                  {t('O_CUSTOMER_DETAILS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_AUCTION_DETAIL)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_AUCTION_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_AUCTION_DETAIL
                  })}
                >
                  {t('O_AUCTION_DETAILS')}
                </button>
              </li>
              <li className='mx-0 xl:mx-5'>
                <button
                  onClick={handleTabClick.bind(this, TAB_APPOINTMENT_DETAIL)}
                  className={classNames({
                    [tabBtnClass]: true,
                    [tabActiveClass]: defaultTab === TAB_APPOINTMENT_DETAIL,
                    [tabBorderNoneClass]: defaultTab !== TAB_APPOINTMENT_DETAIL
                  })}
                >
                  {t('O_APPOINTMENT_DETAILS')}
                </button>
              </li>
            </ul>
          </div>
        </div>
        {defaultTab === TAB_CUSTOMER_DETAIL
          ? (<CustomerDetail item={item} />)
          : defaultTab === TAB_AUCTION_DETAIL
            ? (<AuctionDetail item={item} />)
            : defaultTab === TAB_APPOINTMENT_DETAIL
              ? (<OAppointments userId={item?._id} />)
              : null}
      </div>
    </>
  )
}

export default CustomerViewPage
